var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIncrease = function SvgIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 27",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.661.098v5.44h3.919l-7.59 7.52-7.46-7.384-13.622 13.503L3.98 6.367.102 10.216l16.806 16.651L30.53 13.364l7.46 7.384L49.457 9.386v3.876h5.49V.098z",
    fill: "#00A20B",
    fillRule: "nonzero"
  })));
};

export default SvgIncrease;